import React, { useState, useEffect, useContext } from 'react';
import './App.css';
import { HashRouter } from 'react-router-dom'
// import routes from './routes'
import Routes, { routes } from './routes'
import Amplify, { I18n, Auth } from 'aws-amplify'
import { withAuthenticator } from '@aws-amplify/ui-react'
import awsconfig from "./aws-exports";


// main app w/ routes...

import { UserProvider } from "./UserContext"

// REACT-S-ALERT //
import Alert from 'react-s-alert'

import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/genie.css';
import 'react-s-alert/dist/s-alert-css-effects/flip.css';
import 'react-s-alert/dist/s-alert-css-effects/bouncyflip.css';



Auth.configure(awsconfig)
require('dotenv').config()

function App() {


  return (
    <UserProvider >
      <HashRouter>
        <div className="App">
          <Routes />
          {/* {routes} */}
          <Alert stack={{ limit: 3 }} />
        </div>
      </HashRouter>
    </UserProvider>
  );
}

// export default withAuthenticator(App);
export default App
